import { render, staticRenderFns } from "./PaymentsNeedsReview.vue?vue&type=template&id=9432bc9a&scoped=true&"
import script from "./PaymentsNeedsReview.vue?vue&type=script&lang=ts&"
export * from "./PaymentsNeedsReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9432bc9a",
  null
  
)

export default component.exports